/* template */
<template minapp="mpx" xlang="wxml"><div :class="(classname)" class="es-custom-class"><slot></slot></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m13bbb724"}'>
  .es-tran-shake
    animation shake 800ms ease-in-out
  @keyframes shake
    /* 动画需：“对称”实现 */
    10%, 90%
      transform translate3d(-1px, 0, 0)
    20%, 80%
      transform translate3d(+2px, 0, 0)
    30%, 70%
      transform translate3d(-4px, 0, 0)
    40%, 60%
      transform translate3d(+4px, 0, 0)
    50%
      transform translate3d(-4px, 0, 0)
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m13bbb724"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex13bbb724%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex13bbb724%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m13bbb724"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index13bbb724/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
